import {
  GetAuthorizedEntitiesInput,
  GetAuthorizedEntitiesOutput,
  GetAuthorizedLogisticsPartiesInput,
  GetAuthorizedLogisticsPartiesOutput,
  GetLogisticsPartyDetailsInput,
  GetLogisticsPartyDetailsOutput,
} from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { Observable } from 'rxjs';
import CarrierLogisticsWebServerClient from '../clients/CarrierLogisticsWebServerClient';

export function getAuthorizedLpsService(
  input: GetAuthorizedLogisticsPartiesInput = {}
): Observable<GetAuthorizedLogisticsPartiesOutput> {
  return CarrierLogisticsWebServerClient.getAuthorizedLogisticsParties(input);
}

export function getAuthorizedEntitiesService(
  input: GetAuthorizedEntitiesInput
): Observable<GetAuthorizedEntitiesOutput> {
  return CarrierLogisticsWebServerClient.getAuthorizedEntities(
    GetAuthorizedEntitiesInput.clone(input)
  );
}

export function getLpDetailsService(
  input: GetLogisticsPartyDetailsInput = {}
): Observable<GetLogisticsPartyDetailsOutput> {
  return CarrierLogisticsWebServerClient.getLogisticsPartyDetails(input);
}
